import { PollingProgressDialogReactionResponse } from 'services/Main/types.Component';
import { UseBatchActionDialogReturnProps } from '../../components/lowLevel/BatchActionDialog/useBatchActionDialog';

export default (
  payload: PollingProgressDialogReactionResponse,
  batchActionDialogContext?: UseBatchActionDialogReturnProps
) => {
  if (!batchActionDialogContext)
    throw new Error('Не удалось получить batchActionDialogContext');

  batchActionDialogContext.openBatchActionDialog({
    requestConfig: payload.requestConfig,
  });
};
